import { getRatios } from "./index148.js";
const GetReduceOptionsForDistribution = ({ count, distribution }) => {
	const currDist = getRatios(count);
	let worstMargin = currDist[0] - distribution[0];
	let worstIndices = [0];
	for (let i = 0; i < distribution.length; i++) {
		const newMargin = currDist[i] - distribution[i];
		if (worstMargin > newMargin) continue;
		if (worstMargin === newMargin) {
			worstIndices.push(i);
			continue;
		}
		worstMargin = newMargin;
		worstIndices = [i];
	}
	return worstIndices;
};
export { GetReduceOptionsForDistribution };

//# sourceMappingURL=index246.js.map